import axios from "axios";

// 创建axios实例
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // API基础路径
  timeout: parseInt(process.env.VUE_APP_TIMEOUT) || 10000, // 请求超时时间
});

// 请求拦截器
service.interceptors.request.use(
  (config) => {
    // 在发送请求之前做些什么
    // 例如：添加token
    const token = localStorage.getItem("token");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    // 对请求错误做些什么
    console.error("请求错误：", error);
    return Promise.reject(error);
  },
);

// 响应拦截器
service.interceptors.response.use(
  (response) => {
    // 对响应数据做点什么
    const res = response.data;

    // 判断是否为JSON格式的业务响应数据
    if (res && typeof res === "object" && res.code !== undefined) {
      // 根据后端返回的状态码进行处理
      // 这里假设后端返回的数据结构为 { code, data, message }
      if (res.code !== 200 && res.code !== 1) {
        // 统一处理错误状态码
        console.error("响应错误：", res.msg || res.message || "请求失败");

        // 可以根据不同的状态码进行不同的处理
        // 例如：401 未授权，跳转到登录页
        if (res.code === 401) {
          // 清除本地token
          localStorage.removeItem("token");
          // 使用Vue Router跳转，避免页面刷新（如果使用了Vue Router）
          // window.location.href = "/login"
          console.warn("未授权，请重新登录");
        }

        return Promise.reject(new Error(res.msg || res.message || "请求失败"));
      }
    }

    return res;
  },
  (error) => {
    // 对响应错误做点什么
    console.error("响应错误：", error);

    // 处理不同的HTTP错误状态
    if (error.response) {
      switch (error.response.status) {
        case 401:
          console.error("未授权，请重新登录");
          localStorage.removeItem("token");
          window.location.href = "/login";
          break;
        case 403:
          console.error("拒绝访问");
          break;
        case 404:
          console.error("请求的资源不存在");
          break;
        case 500:
          console.error("服务器内部错误");
          break;
        default:
          console.error(`连接错误${error.response.status}`);
      }
    } else if (error.request) {
      console.error("未收到响应，请检查网络");
    } else {
      console.error("请求配置错误：", error.message);
    }

    return Promise.reject(error);
  },
);

export default service;
